/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import useUtils from './useUtils'
import {useLocation, useNavigate} from 'react-router-dom'
import {FaTimes} from 'react-icons/fa'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const AddAnnouncement = () => {
  const location = useLocation()
  const locationState = location?.state?.values || null
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [announcementOptions, setAnnouncementOptions] = useState([])
  const [typeOptions, setTypeOptions] = useState(['program', 'course', 'module', 'unit', 'video'])

  const {fetchAnnouncementT, createAnnouncement, updateAnnouncement} = useUtils()

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Please enter title'),
    detail: Yup.string().required('Please enter detail'),
    type: Yup.string().required('Please select type'),
    announcementTypeId: Yup.string().required('Please select announcement type'),
  })

  const initialValues = locationState
    ? {
        id: locationState?.id,
        isEdit: true,
        title: locationState.title,
        detail: locationState.detail,
        type: locationState.type,
        announcementType: locationState?.announcementType?.type ?? '',
        announcementTypeId: locationState?.announcementType?.id ?? '',
      }
    : {
        title: '',
        detail: '',
        type: typeOptions[0],
        announcementType: announcementOptions[0]?.type ?? '',
        announcementTypeId: announcementOptions[0]?.id ?? '',
      }

  useEffect(() => {
    const fetchAnnouncementTypes = async () => {
      try {
        const types = await fetchAnnouncementT()
        setAnnouncementOptions(types)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchAnnouncementTypes()
  }, [])

  const handleSubmit = (values) => {
    const data = {
      title: values.title,
      detail: values.detail,
      type: values.type,
      announcementTypeId: values.announcementTypeId,
    }
    if (values.isEdit) {
      updateAnnouncement(values.id, data)
    } else {
      createAnnouncement(data)
    }
  }

  return (
    <>
      <div className='card card-custom'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  <div className='row align-items-start flex-wrap'>
                    {/* Title Field */}
                    <div className='col-lg-4'>
                      <label className='col-form-label required fw-bold fs-6'>Title</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Title'
                        name='title'
                        value={values.title}
                        onChange={handleChange}
                      />
                      {touched.title && errors.title && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.title}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Link Field */}
                    <div className='col-lg-4'>
                      <label className='col-form-label required fw-bold fs-6'>Type</label>
                      <select
                        className='form-select form-select-solid mb-3 mb-lg-0'
                        name='type'
                        value={values.type}
                        onChange={(e) => setFieldValue('type', e.target.value)}
                      >
                         <option value=''>Select Type</option>
                        {typeOptions?.map((val, index) => (
                          <option key={index} value={val}>
                            {val}
                          </option>
                        ))}
                      </select>
                      {touched.type && errors.type && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.type}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className='col-lg-4'>
                      <label className='col-form-label required fw-bold fs-6'>
                        Announcement Type
                      </label>
                      <select
                        className='form-select form-select-solid mb-3 mb-lg-0'
                        name='announcementTypeId'
                        value={values.announcementTypeId}
                        onChange={(e) => setFieldValue('announcementTypeId', e.target.value)}
                      >
                        <option value=''>Select Announcement Type</option>
                        {announcementOptions &&
                          announcementOptions.length > 0 &&
                          announcementOptions?.map((options, index) => (
                            <option key={index} value={options.id}>
                              {options.type}
                            </option>
                          ))}
                      </select>
                      {touched.announcementTypeId && errors.announcementTypeId && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.announcementTypeId}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-12'>
                      <label className='col-form-label required fw-bold fs-6'>Details</label>
                      <textarea
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 '
                        style={{height: '200px', width: '100%'}}
                        placeholder='Write detail'
                        name='detail'
                        value={values.detail}
                        onChange={(e) => {
                          if (e.target.value.length <= 150) {
                            handleChange(e)
                          }
                        }}
                      />
                      <small className='text-muted'>{values.detail.length}/150 characters</small>
                      {touched.detail && errors.detail && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.detail}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Buttons */}
              <div className='d-flex align-items-center justify-content-end my-5'>
                <button
                  type='button'
                  className='btn btn-danger ms-2 mt-2 me-2'
                  onClick={() => navigate('/announcementlist')}
                >
                  Cancel
                </button>
                <button type='button'  onClick={() => {
                    if (values?.isEdit) {
                      setIsOpen(true) // Open the confirmation modal
                    } else {
                      document.querySelector('form')?.requestSubmit() // Directly submit in create mode
                    }
                  }} className='btn btn-primary ms-2 mt-2 me-2'>
                  {!values.isEdit ? 'Submit' : 'Update'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      <AssignConfirmation
        isVisible={isOpen}
        message='Are you sure you want to update this Announcement?'
        onConfirm={() => {
          setIsOpen(false)
          setTimeout(() => {
            document.querySelector('form')?.requestSubmit() // Triggers form submission
          }, 0)
        }}
        onCancel={() => setIsOpen(false)}
      />
    </>
  )
}

export default AddAnnouncement
